import React, { useState } from 'react';
import { Send, Sliders, ShieldAlert, FileText } from 'lucide-react';

// Importe seus componentes aqui (vamos criá-los abaixo)
import FinanceiroPettyCashFormulario from './FinanceiroPettyCashFormulario';
import FinanceiroPettyCashControle from './FinanceiroPettyCashControle';
import FinanceiroPettyCashRelatorio from './FinanceiroPettyCashRelatorio';
import FinanceiroPettyCashAuditoria from './FinanceiroPettyCashAuditoria';

const FinanceiroPettyCash = () => {
    const [activeSubTab, setActiveSubTab] = useState('enviar');

    // Recupera o usuário logado para aplicar travas de menu
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRole = user?.perfil || '';
    
    // Lista de perfis com acesso TOTAL (Relatórios e Auditoria)
    // ⚠️ `Operacional` (28/09/2026): acesso total ao Financeiro (nível Admin).
    const perfisAcessoTotal = ['Admin', 'Financeiro', 'Gerente Adm', 'Auditoria', 'Operacional'];
    const hasFullAccess = perfisAcessoTotal.includes(userRole);

    const renderSubTab = () => {
        switch(activeSubTab) {
            case 'enviar': return <FinanceiroPettyCashFormulario />;
            case 'controle': return <FinanceiroPettyCashControle />;
            case 'relatorio': return hasFullAccess ? <FinanceiroPettyCashRelatorio/> : <FinanceiroPettyCashFormulario />;
            case 'auditoria': return hasFullAccess ? <FinanceiroPettyCashAuditoria/> : <FinanceiroPettyCashFormulario />;
            default: return <FinanceiroPettyCashFormulario />;
        }
    };

    const tabStyle = (isActive) => ({
        display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px',
        backgroundColor: isActive ? '#e0f2f1' : 'transparent',
        color: isActive ? '#16a39c' : '#64748b',
        border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer',
        transition: 'all 0.2s', fontSize: '14px'
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {/* SUB-MENU DO PETTY CASH */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '16px' }}>
                <button onClick={() => setActiveSubTab('enviar')} style={tabStyle(activeSubTab === 'enviar')}>
                    <Send size={18} /> Registrar Despesa
                </button>
                
                <button onClick={() => setActiveSubTab('controle')} style={tabStyle(activeSubTab === 'controle')}>
                    <Sliders size={18} /> Controle
                </button>
                
                {/* Abas restritas a perfis de nível superior */}
                {hasFullAccess && (
                    <>
                        <button onClick={() => setActiveSubTab('relatorio')} style={tabStyle(activeSubTab === 'relatorio')}>
                            <FileText size={18} /> Relatórios
                        </button>
                        <button onClick={() => setActiveSubTab('auditoria')} style={tabStyle(activeSubTab === 'auditoria')}>
                            <ShieldAlert size={18} /> Auditoria
                        </button>
                    </>
                )}
            </div>

            {/* CONTEÚDO DA ABA SELECIONADA */}
            <div style={{ paddingTop: '8px' }}>
                {renderSubTab()}
            </div>
        </div>
    );
};

export default FinanceiroPettyCash;